export { default } from './RatingsTooltip';
